import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { EMPTY, Observable } from 'rxjs';

import { AuthService } from './auth.service';
import { SessionExpiredModalComponent } from '../components/session-expired-modal/session-expired-modal.component';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private modalActive = false;

  constructor(private authService: AuthService, private modalService: NgbModal) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.authService.isLoggedIn) {
      // Clone the request and add the authorization header
      const accessToken = localStorage.getItem('Auth0access_token');
      const IsInternal = localStorage.getItem('Authuser_type');
            const clonedRequest = req.clone({
        setHeaders: {
          Authorization: `Bearer ${accessToken}`,
          IsInternalUser : IsInternal
        }
      });
      return next.handle(clonedRequest);
    } else {
      if (!this.modalActive && !this.authService.authenticating && !this.authService.error) {
        this.openModal();
      }
      return EMPTY;
    }
  }

  private openModal() {
    this.modalActive = true;
    this.modalService
      .open(SessionExpiredModalComponent, this.authService.modalConfig as NgbModalOptions)
      .result.then((result) => {
        this.modalActive = false;
      });
  }
}
